import SEO from '../components/SEO';
import './SimplePage.css';
import ParticleCanvas from '../components/ui/ParticleCanvas';

const TUTORIALS = [
  { title: 'Getting Started with Zepliq', duration: '4:32', category: 'Basics', thumb: '🚀' },
  { title: 'Connect WhatsApp via QR Code', duration: '2:15', category: 'Setup', thumb: '📱' },
  { title: 'Training Your AI Knowledge Base', duration: '6:48', category: 'AI', thumb: '🧠' },
  { title: 'Setting Up Shopify Order Confirmations', duration: '5:20', category: 'E-Commerce', thumb: '🛍️' },
  { title: 'WooCommerce Webhook Integration', duration: '4:55', category: 'E-Commerce', thumb: '🛒' },
  { title: 'Creating Broadcast Campaigns', duration: '3:40', category: 'Broadcasts', thumb: '📢' },
  { title: 'Using the LeadFlow Sales Pipeline', duration: '7:12', category: 'Sales', thumb: '📊' },
  { title: 'Human Takeover and Team Inbox', duration: '3:28', category: 'Team', thumb: '🤝' },
  { title: 'Connecting Gmail to the AI Email Assistant', duration: '4:10', category: 'Email', thumb: '📧' },
  { title: 'Reviewing and Sending AI Email Drafts', duration: '3:35', category: 'Email', thumb: '✉️' },
  { title: 'API and Webhooks Overview', duration: '8:30', category: 'Developer', thumb: '⚙️' },
];

const CATEGORIES = ['All', 'Basics', 'Setup', 'AI', 'E-Commerce', 'Broadcasts', 'Sales', 'Email', 'Developer'];

export default function TutorialsPage() {
  return (
    <div className="simple-page">
      <SEO
        title="Tutorials — How to Use Zepliq WhatsApp Automation (Video Guides)"
        description="Watch Zepliq tutorials: getting started, WhatsApp chatbot setup, AI training, Shopify integration, AI Email Assistant for Gmail, broadcasts, and more. Free video guides for all skill levels."
        keywords="Zepliq tutorials, WhatsApp automation tutorial, how to use Zepliq, WhatsApp chatbot video guide, AI chatbot tutorial, WhatsApp bot setup video"
        canonical="/tutorials"
      />

      <section className="simple-hero">
        <ParticleCanvas className="simple-hero__canvas" />
        <div className="simple-hero__blob simple-hero__blob--1" aria-hidden="true" />
        <div className="simple-hero__blob simple-hero__blob--2" aria-hidden="true" />
        <div className="container simple-hero__inner">
          <span className="badge badge-brand">Video Tutorials</span>
          <h1 className="display-xl simple-hero__title">
            Learn Zepliq<br />
            <span className="gradient-text">step by step.</span>
          </h1>
          <p className="text-lg simple-hero__sub">
            Short, practical video guides covering every feature. From setup to advanced automation — we have got you covered.
          </p>
        </div>
      </section>

      <section className="simple-section section">
        <div className="container">

          <div className="tutorials-filters">
            {CATEGORIES.map(cat => (
              <button key={cat} className={`blog-filter ${cat === 'All' ? 'blog-filter--active' : ''}`}>
                {cat}
              </button>
            ))}
          </div>

          <div className="tutorials-grid">
            {TUTORIALS.map(t => (
              <div key={t.title} className="tutorial-card">
                <div className="tutorial-card__thumb">
                  <span className="tutorial-card__emoji">{t.thumb}</span>
                  <div className="tutorial-card__play">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>
                  </div>
                  <span className="tutorial-card__duration">{t.duration}</span>
                </div>
                <div className="tutorial-card__body">
                  <span className="tutorial-card__cat">{t.category}</span>
                  <h3 className="tutorial-card__title">{t.title}</h3>
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>
    </div>
  );
}
